
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class HiseShowOptionView extends Vue {
  // 🚩 Flag that determines whether the option is positive or negative
  @Prop()
  public variable!: boolean;

  // 📦 Vuex action that should be called on button clicked
  @Prop()
  public action!: string;

  // 📦 The positive option that should be shown as text in the button
  @Prop({ default: "mdi-eye" })
  public positiveOptionIcon!: string;

  // 📦 The positive option that should be shown as text in the button
  @Prop()
  public positiveOptionText!: string;

  // 📦 The negative option that should be shown as text in the button
  @Prop({ default: "mdi-eye-off" })
  public negativeOptionIcon!: string;

  // 📦 The negative option that should be shown as text in the button
  @Prop()
  public negativeOptionText!: string;

  // 🎨 The dark color that should be used for the button
  @Prop({ default: "" })
  public darkModeColor!: string;

  // 🚩 Flag for whether the button should be shown as icon or as text
  @Prop({ default: false })
  public showAsIcon!: string;
}
